/**
 * Labstep
 *
 * @module components/Resource/OrderRequestTemplate
 * @desc ResourceTemplate Show Center OrderRequestTemplate
 */

import { ResourceOrderRequestTemplateEdit } from 'labstep-web/components/Resource/OrderRequestTemplate/Edit';
import { ResourceOrderRequestTemplateEmptyState } from 'labstep-web/components/Resource/OrderRequestTemplate/EmptyState';
import type React from 'react';
import type { ResourceOrderRequestTemplateProps } from './types';

export const ResourceOrderRequestTemplate: React.FC<
  ResourceOrderRequestTemplateProps
> = ({ resource }) =>
  resource.hasNonDeletedOrderRequestTemplate ? (
    <ResourceOrderRequestTemplateEdit resource={resource} />
  ) : (
    <ResourceOrderRequestTemplateEmptyState resource={resource} />
  );
